<template>
    <div class="w-full p-4">
        <div v-for="element in question.options.elements">
            <div class="p-4">
                <LatexMaybe :model-value="element.text" :is-latex="question.is_latex_answers" />
            </div>
        </div>
    </div>
</template>

<script>
import LatexMaybe from '../../LatexMaybe.vue';

export default {
    name: 'QuestionOrderElementsViewOnly',
    components: { LatexMaybe },

    props: {
        question: {
            required: true,
        },
    },
};
</script>
